import {createSlice} from '@reduxjs/toolkit';

interface UserDetailsState {
    userId: string;
}

const initialState: UserDetailsState = { userId: "" };
const userDetailsSlice = createSlice({
    name: 'userDetails',
    initialState,
    reducers:{
        login(state, action){
             state.userId = action.payload;
        },
        logout(state){
             state.userId = "" ;
        }
    }
})

export const {login, logout} = userDetailsSlice.actions;
export default userDetailsSlice.reducer;
